import React from 'react';

export interface QuickAddProps<T> {
	options: T[];
	onSelect: (option: T) => void;
	getValue: (option: T) => string | number;
	getLabel: (option: T) => string;
}

export function QuickAdd<T>(props: QuickAddProps<T>) {
	const handleSelect = (option: T) => {
		props.onSelect(option);
		(document.activeElement as HTMLElement)?.blur();
	};

	if (props.options.length === 0) {
		return null;
	}

	return (
		<div>
			<h3 className="mb-2 text-sm font-medium text-gray-700">Quick Add</h3>
			<div className="flex flex-wrap gap-2">
				{props.options.map(item => (
					<button
						type="button"
						key={props.getValue(item)}
						onClick={() => handleSelect(item)}
						className="rounded-full bg-gray-100 px-4 py-1.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-200"
					>
						{props.getLabel(item)}
					</button>
				))}
			</div>
		</div>
	);
}

export type QuickAddOptionName = {
	id: string | number;
	name: string;
};

export type QuickAddOptionLabel = {
	id: string | number;
	label: string;
};

export type QuickAddOption = QuickAddOptionName | QuickAddOptionLabel;

export interface QuickAddNewProps<T extends QuickAddOption> {
	options: T[];
	onSelect: (option: T) => void;
}

export function QuickAddNew<T extends QuickAddOption>(props: QuickAddNewProps<T>) {
	const handleSelect = (option: T) => {
		props.onSelect(option);
		(document.activeElement as HTMLElement)?.blur();
	};

	if (props.options.length === 0) {
		return null;
	}

	return (
		<div>
			<h3 className="mb-2 text-sm font-medium text-gray-700">Quick Add</h3>
			<div className="flex flex-wrap gap-2">
				{props.options.map(item => (
					<button
						type="button"
						key={item.id}
						onClick={() => handleSelect(item)}
						className="rounded-full bg-gray-100 px-4 py-1.5 text-sm font-medium text-gray-700 transition-colors hover:bg-gray-200"
					>
						{'name' in item ? item.name : item.label}
					</button>
				))}
			</div>
		</div>
	);
}
